import React from 'react'
import Conversations from './conversations'
import { chatSelector } from '../../../../../store/selector';
import { connect } from 'react-redux';

function LeftContent({ type, profile, conversationList, unAssignedList, assignedList, status, disposeList }) {

  if (type === 'conversationScreen') {
    // return <Conversations profile={profile} conversationList={conversationList} />
    return <Conversations profile={profile} unAssignedList={unAssignedList} disposeList={disposeList} assignedList={assignedList} status={status} />
  }
  return <div>yes</div>
  // else if (type === 'profile'){
  //   return <ConversationList data={data} />
  // }
}

// export default index
const stateToProps = state => ({
  type: chatSelector.getChatDynamic(state, 'leftSidebarType'),
  conversationList: chatSelector.getChatDynamic(state, 'conversationList'),
  profile: chatSelector.getChatDynamic(state, 'profile'),
  status: chatSelector.getAgentStatus(state),
  unAssignedList: chatSelector.getChatDynamic(state, 'unAssignedList'),
  assignedList: chatSelector.getChatDynamic(state, 'assignedList'),
  disposeList: chatSelector.getChatDynamic(state, 'disposeList'),

});

export default connect(stateToProps)(LeftContent);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/modules/leftContent/index.js